var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"report-detail"},[(_vm.reportType === 1)?[_c('past-time-debtors-report')]:(_vm.reportType === 2)?[_c('daily-sales-report')]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }